// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-form[data-v-edc85cb6] {\n  margin-bottom: 20px;\n}\n.warp[data-v-edc85cb6] .el-form-item {\n  margin-bottom: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
